export const footerLink = [
  {
    link: "tel: 9691118959",
    title: "Phone",
  },
  {
    link: "https://mail.google.com/mail/?view=cm&fs=1&to=jatinsoni1201@gmail.com&su=SUBJECT&body=BODY",
    title: "E-Mail",
  },
  {
    link: "https://www.linkedin.com/in/jatin-soni-911b8a219/",
    title: "LinkedIn",
  },
  {
    link: "https://github.com/jatin-02",
    title: "GitHub",
  },
];
